// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__13x5z","left":"StickyBox_left__3LGwi","right":"StickyBox_right__2CyEJ"};